import { app } from '../../../../app';
import { Controller } from './add.controller';

app.component('addProfile', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./add.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/add/add.component.js